import { useTranslation } from 'react-i18next';

import { useBreakpointValue } from '@bonusly/design-system';

import { useActionInput } from '../../../context';
import { useActionData } from '../../../hooks';

export const useSubmitText = () => {
	const { t } = useTranslation('action_input', { keyPrefix: 'submit' });
	const { amount, totalAmount, recipientCount } = useActionData();
	const { context = '', budget, giveAmount } = useActionInput();

	const isMobile = useBreakpointValue({ base: true, sm: false });

	const isAward = context.includes('award');
	const isComment = context === 'comment';
	const type = isAward ? 'award' : isComment ? 'comment' : 'give';
	const typeWithAmount = `${type}_with_amount`;
	const currency = budget?.data.display.plural;

	let tooltipText = '';
	let submitText = t(type, { currency });

	// Shorten the submit text on mobile in the give box
	if (isMobile && type === 'give') {
		submitText = t(`${type}_mobile`);
	}

	if (amount) {
		// state for recognition / comment / non-templated award when user adds amount
		submitText = t(typeWithAmount, { amount: budget?.format(amount) });
	}

	if (giveAmount) {
		// templated awards contains the amount on the template reason
		submitText = t(typeWithAmount, { amount: budget?.format(giveAmount) });
	}

	if (totalAmount) {
		// when amount and recipients are present we show the total
		submitText = t(typeWithAmount, { amount: budget?.format(totalAmount) });
	}

	if (recipientCount > 1 && totalAmount) {
		tooltipText = t('tooltip_amount_to', {
			recipients: recipientCount,
			amount: budget?.format(totalAmount / recipientCount),
		});
	}

	return {
		tooltipText,
		submitText,
	};
};
